/* Order reminder for visitors who have books in their cart and are about to leave (desktop only).
   Shown at most once per visit. Costs nothing on page load: the cart is only checked at the moment of exit. */
(function () {
  'use strict';

  var script = document.querySelector('script[data-exit-nudge]');
  if (!script) return;

  var KEY = 'studiz_exit_nudge_shown';
  var threshold = parseInt(script.dataset.threshold, 10) || 0;
  var saleStart = parse(script.dataset.saleStart);
  var saleEnd = parse(script.dataset.saleEnd);
  var openedAt = Date.now();
  var shown = false;

  function parse(str) {
    var m = String(str || '')
      .trim()
      .match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    return m ? Date.UTC(+m[1], +m[2] - 1, +m[3], (+m[4] || 0) - 5, +m[5] || 0) : NaN;
  }

  function seen() {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch (e) {
      return shown;
    }
  }

  function remember() {
    shown = true;
    try {
      sessionStorage.setItem(KEY, '1');
    } catch (e) {
      /* private mode: the in-memory flag is enough */
    }
  }

  /* desktop with a mouse only: phones have no reliable "about to leave" signal */
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (/^\/(cart|checkout|account|customer|orders)/.test(location.pathname)) return;
  if (seen()) return;

  function money(n) {
    return 'Rs. ' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text) node.textContent = text;
    return node;
  }

  function injectStyles() {
    if (document.getElementById('exit-nudge-css')) return;
    var css =
      '.xn{position:fixed;inset:0;z-index:1200;display:flex;align-items:center;justify-content:center;padding:2rem;background:rgba(3,0,46,.6);animation:xnFade .25s ease}' +
      '.xn__card{position:relative;width:100%;max-width:44rem;padding:3.4rem 3.2rem 2.8rem;border-radius:2.6rem;background:rgb(var(--color-background));color:rgb(var(--color-foreground));text-align:center;box-shadow:0 3rem 7rem rgba(0,0,0,.4);animation:xnPop .35s cubic-bezier(.22,.7,.2,1)}' +
      '.xn__icon{display:inline-flex;align-items:center;justify-content:center;width:7rem;height:7rem;margin-bottom:1.4rem;border-radius:50%;background:rgba(var(--color-button),.1);font-size:3.4rem}' +
      '.xn__title{margin:0;font-size:2.6rem;font-weight:800;line-height:1.2}' +
      '.xn__text{margin:1.2rem 0 0;font-size:1.6rem;line-height:1.55;color:rgba(var(--color-foreground),.72)}' +
      '.xn__text strong{color:rgb(var(--color-foreground))}' +
      '.xn__hint{display:inline-block;margin:1.6rem 0 0;padding:.8rem 1.6rem;border-radius:10rem;background:#fff4d6;color:#7a5200;font-size:1.35rem;font-weight:700}' +
      '.xn__go{display:flex;align-items:center;justify-content:center;width:100%;min-height:5.4rem;margin-top:2.2rem;padding:0 2.4rem;border:0;border-radius:1.2rem;background:rgb(var(--color-button));color:rgb(var(--color-button-text));font:inherit;font-size:1.7rem;font-weight:800;letter-spacing:.02em;text-decoration:none;cursor:pointer}' +
      '.xn__go:hover{box-shadow:0 .6rem 1.8rem rgba(var(--color-button),.4)}' +
      '.xn__skip{margin-top:1.2rem;padding:1rem;border:0;background:none;color:rgba(var(--color-foreground),.65);font:inherit;font-size:1.4rem;text-decoration:underline;cursor:pointer}' +
      '.xn__close{position:absolute;top:1.2rem;right:1.2rem;display:flex;align-items:center;justify-content:center;width:3.8rem;height:3.8rem;border:0;border-radius:50%;background:rgba(var(--color-foreground),.07);color:inherit;font-size:2rem;line-height:1;cursor:pointer}' +
      '.xn__go:focus-visible,.xn__skip:focus-visible,.xn__close:focus-visible{outline:.3rem solid rgb(var(--color-foreground));outline-offset:.3rem}' +
      '@keyframes xnFade{from{opacity:0}to{opacity:1}}@keyframes xnPop{from{opacity:0;transform:translateY(1.6rem) scale(.97)}to{opacity:1;transform:none}}' +
      '@media (prefers-reduced-motion:reduce){.xn,.xn__card{animation:none}}';
    var style = document.createElement('style');
    style.id = 'exit-nudge-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function open(cart) {
    if (shown || document.querySelector('.xn')) return;
    remember();
    injectStyles();

    var count = cart.item_count;
    var total = cart.total_price / 100;
    var previous = document.activeElement;

    var overlay = el('div', 'xn');
    var card = el('div', 'xn__card');
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-modal', 'true');
    card.setAttribute('aria-labelledby', 'xn-title');

    var close = el('button', 'xn__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');

    card.appendChild(close);
    card.appendChild(el('div', 'xn__icon', '📚'));
    card.appendChild(el('h2', 'xn__title', 'Wait! Your books are waiting'));

    var text = el('p', 'xn__text');
    text.appendChild(document.createTextNode('You have '));
    text.appendChild(el('strong', '', count + (count === 1 ? ' item' : ' items')));
    text.appendChild(document.createTextNode(' in your cart (' + money(total) + '). Place your order now. Cash on Delivery is available all over Pakistan.'));
    card.appendChild(text);

    var hint = '';
    var now = Date.now();
    if (!isNaN(saleEnd) && now >= saleStart && now < saleEnd) {
      var left = Math.floor((saleEnd - now) / 1000);
      var d = Math.floor(left / 86400);
      var h = Math.floor((left % 86400) / 3600);
      var m = Math.floor((left % 3600) / 60);
      hint = 'The sale ends in ' + (d ? d + 'd ' : '') + h + 'h ' + m + 'm';
    } else if (threshold && total < threshold) {
      hint = 'Add ' + money(threshold - total) + ' more for FREE delivery';
    }
    if (hint) card.appendChild(el('span', 'xn__hint', hint));

    var go = el('a', 'xn__go', 'Complete my order →');
    go.href = '/checkout';
    card.appendChild(go);

    var skip = el('button', 'xn__skip', 'Keep browsing');
    skip.type = 'button';
    card.appendChild(skip);

    overlay.appendChild(card);
    document.body.appendChild(overlay);
    go.focus();

    function dismiss() {
      document.removeEventListener('keydown', onKey);
      overlay.remove();
      if (previous && previous.focus) previous.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') dismiss();
    }
    document.addEventListener('keydown', onKey);
    close.addEventListener('click', dismiss);
    skip.addEventListener('click', dismiss);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismiss();
    });
  }

  function onLeave(e) {
    if (e.relatedTarget || e.clientY > 8) return;
    if (shown || Date.now() - openedAt < 6000) return;
    if (document.querySelector('cart-drawer.active, cart-drawer[open], .xn')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (cart && cart.item_count > 0 && !document.hidden) open(cart);
      })
      .catch(function () {});
  }

  document.addEventListener('mouseout', onLeave);
})();
